module.exports = __webpack_public_path__ + "static/media/2.6b5ea28c.jpg";